module.exports = __webpack_public_path__ + "img/2.37c85da0.svg";